export enum TFilterOption {
  date, hash
}
